const React = require("react");
const {pdf} = require("@react-pdf/renderer");
const {base: downloadBase} = require("mn-utils/browser/download");
const getTime = require("mn-utils/time");

const {KycPdfTemplate} = require("../components/dumb/PdfTemplates");

module.exports = async (userData) => {
  const Component = <KycPdfTemplate data={userData} />
  const blob = await pdf(Component).toBlob();

  const companyName = ((userData.company || {}).company || {}).company_name;

  downloadBase(
    URL.createObjectURL(blob),
    companyName ? `${companyName}.pdf` : `${getTime()}.pdf`
  );
}
